import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { cn } from 'lib/utils';

export default function ToggleContainer({ sideMenu, mainContent, classNames = {} }) {
  const [init, setInit] = useState(false);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (mainContent && !init) {
      setInit(true);
      setOpen(false);
    }
  }, [mainContent]);

  return (
    <div className="tw-flex tw-w-full tw-h-full">
      <div className={cn(`tw-transition-all tw-duration-300`, open ? classNames.sideMenu ?? 'tw-w-[400px]' : 'tw-w-0')}>
        <div className={cn(`tw-min-h-screen`, open ? 'tw-opacity-100' : 'tw-opacity-0')}>{sideMenu}</div>
      </div>

      {init && (
        <div className="tw-flex-1 tw-px-4 tw-relative tw-min-w-0">
          <button
            className="hover:tw-no-underline tw-font-semibold tw-px-[10px] tw-py-[6px] tw-border tw-border-solid tw-bg-[#323333] tw-text-white"
            onClick={() => setOpen(!open)}
          >
            {/* <FontAwesomeIcon icon={open ? faChevronLeft : faChevronRight} /> */}
            {open ? 'Pin Menu' : 'Menu'}
          </button>
          <div className="tw-mt-0">{mainContent}</div>
        </div>
      )}
    </div>
  );
}
